import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { PourAvailabilityDeleteCard } from './components/PourAvailabilityDeleteCard';
import { PourAvailabilityDetailsCard } from './components/PourAvailabilityDetailsCard';

export function PourAvailabilityDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const menuItemQueryResults = useQuery({
        queryKey: ['businessPourAvailability', id],
        queryFn: () =>
            Api.BusinessSpecific.PourAvailability.getPourAvailability(
                Number(id)
            ),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={menuItemQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <PourAvailabilityDetailsCard pourAvailability={data} />

                        <Can I="delete" a="PourAvailability">
                            <PourAvailabilityDeleteCard
                                pourAvailability={data}
                            />
                        </Can>
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
